import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2402">
      <div className="dark" data-id="element-2403">
        <Hero data-id="element-2404" />
      </div>
      <WhyUs data-id="element-2405" />
      <ByTheNumbers data-id="element-2406" />
      <Services data-id="element-2407" />
      <HowItWorks data-id="element-2408" />
      <FAQ data-id="element-2409" />
      <Reviews data-id="element-2410" />
      <CtaBanner data-id="element-2411" />
    </main>;
}